import { useState } from "react"
import { FiX } from "react-icons/fi"
import Button from "../ui/Button"
import { Input } from "../ui/shadcn/input"

export default function ApiKeyModal({onClose, apiKey}) {
    const [newApiKey, setNewApiKey] = useState({
        name: 'New API key',
        ...apiKey
    })

    return (
        <div className='w-full h-full max-w-[500px] flex flex-col bg-background border-l'>
            <div className='flex justify-between py-2 px-4  items-center'>
                <span className='text-secondary-foreground text-lg font-bold'>New API Key</span>
                <div className='cursor-pointer text-gray-400 hover:text-white' onClick={() => onClose(null)}><FiX className="w-6 h-6" /></div>
            </div>
            <div className='flex-1 overflow-hidden p-4'>
                <div className='flex flex-col gap-2'>
                    <label htmlFor="name" className='text-xs text-secondary-foreground'>Name</label>
                    <Input type="text" id="name" name="name" defaultValue={newApiKey.name} onChange={(e) => setNewApiKey({...newApiKey, name: e.target.value})} />
                </div>
            </div>
            <div className='flex justify-end p-4 gap-4'>
                <Button type='danger-ghost' className='min-w-20' onClick={() => onClose(null)}>Cancel</Button>
                <Button type='primary' className='min-w-20' onClick={() => onClose(newApiKey)}>Save</Button>
            </div>
        </div>
    )
}